import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import newLogo2 from "../../image/logo.png";

const NavBar = () => {
  const ref = useRef();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Structured Data Schema for Site Navigation (Google Search Sitelinks)
  const navSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://www.polopvc.com/#website",
        "url": "https://www.polopvc.com/",
        "name": "PoloPipes",
        "description": "Leading manufacturer of PVC, CPVC & UPVC pipes for plumbing, drainage & agriculture."
      },
      {
        "@type": "ItemList",
        "itemListElement": [
          {
            "@type": "SiteNavigationElement",
            "position": 1,
            "name": "About Us",
            "url": "https://www.polopvc.com/about"
          },
          {
            "@type": "SiteNavigationElement",
            "position": 2,
            "name": "Products",
            "url": "https://www.polopvc.com/products"
          },
          {
            "@type": "SiteNavigationElement",
            "position": 3,
            "name": "Infrastructure",
            "url": "https://www.polopvc.com/infrastructure"
          },
          {
            "@type": "SiteNavigationElement",
            "position": 4,
            "name": "News & Media",
            "url": "https://www.polopvc.com/news&media"
          },
          {
            "@type": "SiteNavigationElement",
            "position": 5,
            "name": "Careers",
            "url": "https://www.polopvc.com/careers"
          },
          {
            "@type": "SiteNavigationElement",
            "position": 6,
            "name": "Contact Us",
            "url": "https://www.polopvc.com/contact"
          }
        ]
      }
    ]
  };

  const menuOption = [
    {
      name: "About Us",
      isExpand: true,
      isIconOpen: false,
      subItem: ["About PoloPipes", "History", "Director Statement"],
      path: ["about", "history", "testimonials"],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
        </svg>
      ),
      icons: [
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-orange-500">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-orange-500">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-orange-500">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
        </svg>,
      ],
    },
    {
      name: "Products",
      isExpand: false,
      path: "products",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
        </svg>
      ),
    },
    {
      name: "Infrastructure",
      isExpand: false,
      path: "infrastructure",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
        </svg>
      ),
    },
    {
      name: "News & Media",
      isExpand: false,
      path: "news&media",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
        </svg>
      ),
    },
    {
      name: "Careers",
      isExpand: false,
      path: "careers",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
        </svg>
      ),
    },
    {
      name: "Contact Us",
      isExpand: false,
      path: "contact",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z" />
        </svg>
      ),
    },
  ];

  const [navItem, setNavItem] = useState(menuOption);

  useEffect(() => {
    const listenScrollEvent = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", listenScrollEvent);
    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  const resetDropdownStates = useCallback(() => {
    setNavItem((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        isIconOpen: false,
      }))
    );
  }, []);

  useEffect(() => {
    setOpen(false);
    resetDropdownStates();
  }, [location, resetDropdownStates]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        resetDropdownStates();
      }
    };

    window.addEventListener("mousedown", checkIfClickedOutside);
    return () => window.removeEventListener("mousedown", checkIfClickedOutside);
  }, [resetDropdownStates]);

  const menuClicked = (menuIndex, subMenuIndex) => {
    const updatedItems = navItem.map((item, index) => {
      if (index === menuIndex && item.isExpand) {
        return { ...item, isIconOpen: !item.isIconOpen };
      }
      return { ...item, isIconOpen: false };
    });

    if (!navItem[menuIndex].isExpand || subMenuIndex !== undefined) {
      setOpen(false);
    }
    setNavItem(updatedItems);
  };

  return (
    <>
      {/* Google Site Navigation Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(navSchema) }}
      />

      <header
        ref={ref}
        className={`sticky top-0 z-50 w-full transition-all duration-300 font-sans ${
          isScrolled
            ? "bg-gradient-to-r from-orange-600 via-amber-600 to-orange-600 shadow-xl py-2.5 backdrop-blur-md"
            : "bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 py-3.5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">

            {/* Logo Brand Segment */}
            <div className="flex items-center">
              <Link className="flex items-center space-x-3 group focus:outline-none" to="/">
                <div className="bg-white p-2 rounded-xl shadow-md group-hover:bg-orange-50 transition-all flex items-center justify-center">
                  <img
                    alt="PoloPipes Logo"
                    className={`object-contain transition-all duration-300 ${
                      isScrolled ? "w-9 h-7" : "w-11 h-9"
                    }`}
                    src={newLogo2}
                  />
                </div>
                <div className="text-white flex flex-col justify-center">
                  <span className={`font-black tracking-tight leading-none transition-all duration-300 ${
                    isScrolled ? "text-xl sm:text-2xl" : "text-2xl sm:text-3xl"
                  }`}>
                    PoloPipes
                  </span>
                  <span className="text-[10px] font-bold tracking-wide opacity-95 skew-x-[-6deg] mt-1 whitespace-nowrap text-orange-100 hidden sm:block">
                    Ultimate Solution of Water
                  </span>
                </div>
              </Link>
            </div>

            {/* Desktop Web Layout Link List */}
            <nav className="hidden lg:flex items-center space-x-6" aria-label="Main Navigation">
              {navItem.map((item, menuIndex) => (
                <div key={menuIndex} className="relative">
                  {item.isExpand ? (
                    <button
                      onClick={() => menuClicked(menuIndex)}
                      className="flex items-center space-x-1.5 text-xs sm:text-sm font-bold text-white/95 hover:text-white transition-colors focus:outline-none cursor-pointer py-2"
                    >
                      <span>{item.name}</span>
                      <svg
                        className={`h-4 w-4 transform transition-transform duration-200 ${
                          item.isIconOpen ? "rotate-180" : "rotate-0"
                        }`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                  ) : (
                    <Link
                      to={`/${item.path}`}
                      className="text-xs sm:text-sm font-bold text-white/95 hover:text-white transition-colors focus:outline-none py-2 block"
                    >
                      {item.name}
                    </Link>
                  )}

                  {/* Dropdown Options Frame */}
                  {item.isExpand && item.isIconOpen && (
                    <div className="absolute left-1/2 transform -translate-x-1/2 mt-3 w-56 bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-slate-200/80 py-2 z-50 animate-fadeIn">
                      {item.subItem.map((sub, subIndex) => (
                        <Link
                          key={subIndex}
                          onClick={() => menuClicked(menuIndex, subIndex)}
                          to={`/${item.path[subIndex]}`}
                          className="flex items-center space-x-3 px-4 py-2.5 text-xs sm:text-sm text-slate-700 hover:bg-orange-50 hover:text-orange-600 font-semibold transition-colors"
                        >
                          {item.icons[subIndex]}
                          <span>{sub}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>

            {/* Drawer Hamburger Trigger */}
            <div className="flex lg:hidden">
              <button
                type="button"
                className="p-2 rounded-xl text-white hover:bg-white/10 focus:outline-none transition-all cursor-pointer"
                onClick={() => setOpen(!open)}
                aria-label="Toggle menu"
              >
                {open ? (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>
            </div>

          </div>
        </div>

        {/* Responsive Overlay Mobile Drawer Box */}
        {open && (
          <div className="lg:hidden fixed inset-0 top-[60px] z-40 bg-slate-950/50 backdrop-blur-xs flex justify-end transition-opacity duration-300">
            <div className="w-full max-w-xs bg-white h-screen shadow-2xl overflow-y-auto px-6 py-6 border-l border-slate-200/80 flex flex-col justify-between animate-slideIn">
              <div className="flex flex-col space-y-6">
                <nav className="flex flex-col space-y-2" aria-label="Mobile Navigation">
                  {navItem.map((item, menuIndex) => (
                    <div key={menuIndex} className="w-full">
                      <div
                        onClick={() => menuClicked(menuIndex)}
                        className="flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 text-slate-800 hover:text-orange-600 transition-colors font-bold text-sm sm:text-base cursor-pointer"
                      >
                        <div className="flex items-center space-x-3">
                          <span className="text-slate-400">{item.icon}</span>
                          {item.isExpand ? (
                            <span>{item.name}</span>
                          ) : (
                            <Link to={`/${item.path}`} className="w-full block">{item.name}</Link>
                          )}
                        </div>
                        {item.isExpand && (
                          <svg
                            className={`h-4 w-4 transform transition-transform duration-200 ${
                              item.isIconOpen ? "rotate-180" : "rotate-0"
                            }`}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>

                      {/* Mobile Nested Subitems */}
                      {item.isExpand && item.isIconOpen && (
                        <div className="mt-1 ml-6 pl-2 border-l border-slate-200/80 flex flex-col space-y-1">
                          {item.subItem.map((sub, subIndex) => (
                            <Link
                              key={subIndex}
                              onClick={() => menuClicked(menuIndex, subIndex)}
                              to={`/${item.path[subIndex]}`}
                              className="flex items-center space-x-3 px-4 py-2.5 text-xs sm:text-sm text-slate-600 hover:bg-orange-50 hover:text-orange-600 font-semibold rounded-xl transition-colors"
                            >
                              {item.icons[subIndex]}
                              <span>{sub}</span>
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </nav>
              </div>

              <div className="pt-6 text-center text-slate-400 text-xs border-t border-slate-100">
                <p className="font-semibold tracking-wide">&copy; PoloPipes Private Limited</p>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default NavBar;